const lang = {
    en: require('./en.json'),
    zh: require('./zh.json'),
    ja: require('./en.json')
}

export default lang